<template>
  <el-menu
    :default-active="activeIndex"
    :mode="mode"
    unique-opened
    @select="handleSelect"
    background-color="#f5f5f5"
    active-text-color="#EE0000"
  >
    <el-menu-item index="/">首页</el-menu-item>
    <el-submenu index="2">
      <template slot="title">企业概况</template>
      <el-menu-item index="/introduce">公司介绍</el-menu-item>
      <el-menu-item index="/honor">企业荣誉</el-menu-item>
      <el-menu-item index="/team">团队风采</el-menu-item>
      <el-menu-item index="/album">钢友画册</el-menu-item>
    </el-submenu>
    <el-submenu index="3">
      <template slot="title">产品中心</template>
      <el-menu-item index="/product">产品中心</el-menu-item>
      <el-menu-item index="/photovoltaic">光伏支架</el-menu-item>
      <el-menu-item index="/steelstructure">钢结构</el-menu-item>
    </el-submenu>
    <el-menu-item index="/produce">加工生产</el-menu-item>
    <el-menu-item index="/weldedpipe">钢友钢管</el-menu-item>
    <el-menu-item index="/logisticsintroduce">钢友物流</el-menu-item>
    <el-menu-item index="/business">商管中心</el-menu-item>
    <el-menu-item index="/metal">钢友金属</el-menu-item>
    <el-menu-item index="/greenenergy">绿色钢友 — 光储充一体化</el-menu-item>
    <el-menu-item index="/vr">全景钢友</el-menu-item>
    <el-menu-item index="/news">新闻中心</el-menu-item>
    <el-menu-item index="/dynamic">党建之窗</el-menu-item>
    <el-menu-item index="/contact">联系我们</el-menu-item>
  </el-menu>
</template>
<script>

// import MenuItem from "./menuItem.vue";

export default {
  props: {
    mode: {
      type: String,
      default: "horizontal ",
    },
  },
  components: {
    // MenuItem,
  },
  data() {
    return {
      activeIndex: "/",
    };
  },
  methods: {
    handleSelect(key) {
      if (key === "/vr") {
        window.open("/vr");
      } else {
        this.$router.push(key);
        this.$emit("hiddenHandle");
      }
    },
  },
};
</script>

<style scoped lang="less"></style>
